import { css } from "styled-components";
import { ctaTransitionEffectMixin } from "../mixins";
import { riotProductSkin } from "../riot-product";
export const lionSkin = (chroma, paletteTokens) => css `
  ${riotProductSkin(chroma, paletteTokens)}
  text-transform: none;

  &.variant-primary {
    --project-l-cta-after-bg-color: ${paletteTokens.ctastroke1};
    --project-l-cta-after-hover-bg-color: ${paletteTokens.ctastroke1_hover};
  }

  &.variant-secondary {
    --project-l-cta-after-bg-color: ${paletteTokens.ctastroke2};
    --project-l-cta-after-hover-bg-color: ${paletteTokens.ctastroke2};
  }

  &.variant-primary,
  &.variant-secondary {
    outline-offset: 5px;
    padding: 20px 40px;
    position: relative;
    ${chroma.typography.display8}
    /* polygon background */
    clip-path: polygon(0 50%, 18px 0, calc(100% - 18px) 0, 100% 50%, calc(100% - 18px) 100%, 18px 100%, 0 50%);

    /* polygon outline */
    &::after {
      ${ctaTransitionEffectMixin}
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: var(--project-l-cta-after-bg-color);
      clip-path: polygon(
        -1px 50%,
        17px -1px,
        calc(101% - 19px) -1px,
        101% 50%,
        calc(101% - 19px) 101%,
        17px 101%,
        -1px 50%,

        4px 50%,
        20px calc(100% - 3px),
        calc(100% - 20px) calc(100% - 3px),
        calc(100% - 4px) 50%,
        calc(100% - 20px) 3px,
        20px 3px,
        4px 50%
      );
    }

    &:hover:not(.disabled) {
      &::after {
        background-color: var(--project-l-cta-after-hover-bg-color);
      }
    }
  }

  &.variant-tertiary {
    ${chroma.typography.textLink};
    color: ${paletteTokens.ctatext2};

    .tertiary-icon {
      width: 12px;
      height: 12px;

      ${chroma.mediaQueries.mobileDown} {
        width: 10px;
        height: 10px;
      }
    }

    &:hover:not(.disabled) {
      color: ${paletteTokens.ctatext1_hover};

      .tertiary-icon {
        background-color: ${paletteTokens.ctatext1_hover};
      }
    }
  }
`;
//# sourceMappingURL=index.js.map